import { createBrowserRouter, RouterProvider } from 'react-router';
import Login from './components/login/Login';
import CustomerLogin from './components/customer/login/CustomerLogin';
import { roleGuard } from './guards/AuthGuard';
import { LOGIN, SIGN_UP, CUSTOMER_LOGIN, CUSTOMER_DASHBOARD } from './services/constants/URIConstants';
import AdminStickLayout from './layout/AdminStickLayout';
import LendingDashboard from './components/dashboard/LendingDashboard';
import CustomerManagement from './components/customers/CustomerManagement';
import CustomerDebitsView from './components/customers/CustomerDebitsView';
import CustomerDetailsView from './components/customers/CustomerDetailsView';
import EditCustomerForm from './components/customers/EditCustomerForm';
import CashflowDashboard from './components/admin/cashflow/CashflowDashboard';
import LeadsManagement from './components/admin/leads/LeadsManagement';
import ProductManagement from './components/admin/products/ProductManagement';
import PaymentsAndDebits from './components/admin/payments/PaymentsAndDebits';
import InterestRequestsManagement from './components/admin/interest-requests/InterestRequestsManagement';
import AnnualFinancialSummary from './components/admin/reports/AnnualFinancialSummary';
import RevenueCashflowReport from './components/admin/reports/RevenueCashflowReport';
import InterestCollectedCurrentMonth from './components/admin/reports/InterestCollectedCurrentMonth';
import CustomerDepositsMonitoring from './components/admin/deposits/CustomerDepositsMonitoring';
import Settings from './components/admin/settings/Settings';
import HomeScreen from './components/home/HomeScreen';
import ServicesPage from './components/services/ServicesPage';
import SignupForm from './components/signup/SignupForm';
import CustomerDashboard from './components/customer/dashboard/CustomerDashboard';



export default function AppRoutes(props: any): React.ReactElement {
  const isDevelopment = process.env.NODE_ENV !== 'production';
  
  const baseRoutes = [
    {
      path: '/',
      Component: HomeScreen,
    },
    {
      path: '/services',
      Component: ServicesPage,
    },
    { 
      path: 'admin',
      Component: AdminStickLayout,
      loader: roleGuard.adminProtectedLoader, // Only allow admin access
      children: [
        {
          path: 'dashboard',
          Component: LendingDashboard,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'customers',
          Component: CustomerManagement,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'customers/:customerId',
          Component: CustomerDetailsView,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'customers/:customerId/edit',
          Component: EditCustomerForm,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'customers/:customerId/debits',
          Component: CustomerDebitsView,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'deposits-monitoring',
          Component: CustomerDepositsMonitoring,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'cashflow',
          Component: CashflowDashboard,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'leads',
          Component: LeadsManagement,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'products',
          Component: ProductManagement,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'payments',
          Component: PaymentsAndDebits,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'financial-summary',
          Component: AnnualFinancialSummary,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'revenue-cashflow',
          Component: RevenueCashflowReport,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'interest-collected-month',
          Component: InterestCollectedCurrentMonth,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'interest-requests',
          Component: InterestRequestsManagement,
          loader: roleGuard.adminProtectedLoader,
        },
        {
          path: 'settings',
          Component: Settings,
          loader: roleGuard.adminProtectedLoader,
        },
      ],
    },
    {
      path: 'customer',
      children: [
        {
          path: 'dashboard',
          Component: CustomerDashboard,
          loader: roleGuard.customerProtectedLoader,
        },
      ],
    },
    {
      path: LOGIN,
      Component: Login
    },
    {
      path: CUSTOMER_LOGIN,
      Component: CustomerLogin
    },
  ];

  // Only add signup route in development
  if (isDevelopment) {
    baseRoutes.push({
      path: SIGN_UP,
      Component: SignupForm
    });
  }

  baseRoutes.push({
    path: '*',
    Component: HomeScreen,
  });

  const routes = createBrowserRouter(baseRoutes);

  return <RouterProvider router={routes} />;
}
